module.exports = __webpack_public_path__ + "img/classes_icon_pink.723f79d4.svg";